window.$ = window.jQuery = require("jquery");
require("./validation");
const { $err } = require("./error-manager");

export function EmailCartManager() {
    var self = this;
    self.url = window.jrConfig.jrApiUrl + "/cart";
    self.recaptchaId = null;

    self.loadRecaptcha = function(callback) {
        if (typeof grecaptcha === "undefined") {
            $.ajax({
                url: "https://www.google.com/recaptcha/api.js",
                dataType: "script",
                success: callback,
                async: true
            });
        } else {
            callback();
        }
    };

    self.emailCartModal = function(ev) {
        var url = $(this).data("content");
        if (url) {
            self.loadRecaptcha(function() {
                if (self.recaptchaId !== null) {
                    window.grecaptcha.reset(self.recaptchaId);
                    self.recaptchaId = null;
                }

                $("#genericModal")
                    .find(".modal-content")
                    .html("");
                $("#genericModal")
                    .find(".modal-content")
                    .load(url, function() {
                        self.recaptchaId = window.grecaptcha.render("emailCart_recaptcha", {
                            sitekey: $("#emailCart_recaptcha").data("sitekey")
                        });

                        $('form[name="emailCart"]').validate({
                            submitHandler: function(form) {
                                $("#genericModal button, #genericModal input").attr(
                                    "disabled",
                                    "disabled"
                                );
                                $(".email-cart-error-container").html("");
                                $.ajax({
                                    dataType: "json",
                                    url: self.url + "/email-cart",
                                    method: "POST",
                                    data: {
                                        email: $(form)
                                            .find('input[name="email"]')
                                            .val(),
                                        "g-recaptcha-response": window.grecaptcha.getResponse(
                                            self.recaptchaId
                                        )
                                    },
                                    success: function(/* res */) {
                                        $(".email-cart-success").show();
                                        $('form[name="emailCart"]').hide();
                                        $("#genericModal button, #genericModal input").removeAttr(
                                            "disabled"
                                        );
                                    },
                                    error: function(err) {
                                        window.grecaptcha.reset(self.recaptchaId);
                                        $("#genericModal button, #genericModal input").removeAttr(
                                            "disabled"
                                        );
                                        $err.ajaxError(err, ".email-cart-error-container");
                                    }
                                });
                            }
                        });

                        $("#genericModal").modal();
                    });
            });
        }
        ev.preventDefault();
        return false;
    };

    self.bind = function() {
        $(".email-cart")
            .unbind("click")
            .click(self.emailCartModal);
    };

    self.bind();
}

export const $em = new EmailCartManager();
